import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IRecordViewProcess } from '../model/model';
import { ServiceService } from '../service/service.service';
import { ElementsService, BillOperate } from 'dbweb-core';

@Component({
	selector: 'common-footer-toolbar',
	templateUrl: './footer-toolbar.component.html',
	styleUrls: ['./footer-toolbar.component.scss']
})
export class FooterToolbarComponent implements OnInit {
	@Input() class: string;
	@Input() process: IRecordViewProcess[];
	@Input() pageSize: number;
	@Input() startRowNo: number;
	@Input() rowCount: number; // -1 ä»£è¡¨æªç¥
	@Input() responseTime: number;
	@Input() refreshDisable = false;
	@Input() nextPageDisable = false;
	@Input() PrevPageDisable = false;
	@Output() processClick = new EventEmitter<IRecordViewProcess>();
	@Output() rowCountClick = new EventEmitter<MouseEvent>();
	@Output() prevPageClick = new EventEmitter<MouseEvent>();
	@Output() nextPageClick = new EventEmitter<MouseEvent>();
	Math = Math;
	wingAnimation: boolean; // ç¨æ¥æ§å¶ç¿èæ¯å¦å±å¼
	constructor(public svr: ServiceService, private eles: ElementsService) {}

	ngOnInit() {}
	pageText() {
		// å°äº0ï¼åæ¯ä¸ç¥éè®°å½æ»æ°
		if (this.rowCount > 0) {
			return `${Math.ceil(this.startRowNo / this.pageSize)}/${Math.ceil(this.rowCount / this.pageSize)}é¡µ`;
		}
		return `ç¬¬${Math.ceil(this.startRowNo / this.pageSize)}é¡µ`;
	}
	rowCountText() {
		if (this.rowCount >= 0) {
			return `${this.rowCount.toString()}`;
		}
		return '/';
	}
	responseTimeText() {
		if (this.responseTime > 1) {
			return this.responseTime.toFixed(2) + ' s';
		} else {
			return (this.responseTime * 1000).toFixed(0) + ' ms';
		}
	}
}
